/**
 * Functions acting on or creating URLs taken from Dora/App
 */

import { pipe } from 'fp-ts/lib/function';

export enum QueryParam {
    FromQrCode = 'fromQrCode',
    LaunchIntent = 'launchIntent',
    LaunchProductId = 'launchProductId',
}

export type LaunchIntent = 'explore';

export const url = (s: string): URL => new URL(s);
export const toString = (u: URL): string => u.toString();

/** Warning: not pure */
export const fromQrCode = (url: URL): URL => {
    url.searchParams.set(QueryParam.FromQrCode, '1');
    return url;
};

/** Warning: not pure */
export const launchIntent =
    (intent: LaunchIntent) =>
    (url: URL): URL => {
        url.searchParams.set(QueryParam.LaunchIntent, intent);
        return url;
    };

/** Warning: not pure */
export const launchProductId =
    (productId: string) =>
    (url: URL): URL => {
        url.searchParams.set(QueryParam.LaunchProductId, productId);
        return url;
    };

/** Given a base URL and a productId, create a URL which will trigger the AR experience in Explore on landing */
export const launchExploreFromQrCode = (base: string, productId: string): URL =>
    pipe(new URL(base), fromQrCode, launchIntent('explore'), launchProductId(productId));

export const launchExploreFromLink = (base: string, productId: string): URL =>
    pipe(new URL(base), launchIntent('explore'), launchProductId(productId));
